<template>
    <div class="v-notification-block" v-if="store.banners.length">
        <transition-group name="banner">
            <div v-for="banner in store.banners" :key="banner.id" class="notification-banner"
                :class="['notification-banner--' + banner.type]">
                <div class="banner-content">
                    <simple-svg v-if="banner.type === 'warning' || banner.type === 'error'" :src="WarningIcon"
                        :width="20" :height="20"
                        :custom-class-name="banner.type === 'error' ? 'icon-red' : 'icon-yellow'"></simple-svg>

                    <simple-svg v-if="banner.type === 'info'" :src="InfoIcon" :width="20" :height="20"
                        custom-class-name="icon-blue"></simple-svg>

                    <span>{{ banner.message }}</span>
                    <span v-if="banner.button" @click="banner.button.action()" class="banner-button">{{
                        banner.button.text }}</span>
                </div>
                <button class="banner-close" @click="store.removeBanner(banner.id)">
                    <simple-svg :src="CloseIcon" :width="16" :height="16" custom-class-name="icon"></simple-svg>
                </button>
            </div>
        </transition-group>
    </div>
    <VerifyEmailPopup v-model="userStore.isVerifyEmailVisible" />
</template>

<script setup>
import { useNotificationStore } from '@/store/NotificationStore';
import { useUserStore } from '@/store/UserStore';
import WarningIcon from '@/assets/icons/Circle_Warning.svg';
import CloseIcon from '@/assets/icons/Close_MD.svg';
import InfoIcon from '@/assets/icons/Circle_Check.svg';
import VerifyEmailPopup from '@/components/common/VerifyEmailPopup.vue';

const store = useNotificationStore();
const userStore = useUserStore();
</script>

<style lang="scss">
.v-notification-block {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
}

.notification-banner {

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    border: 1px solid transparent;
    border-radius: 10px;

    &__content {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .banner-content {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;

        .banner-button {
            cursor: pointer;
            color: var(--color-blue);
        }
    }

    .banner-close {
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.6;
        transition: opacity 0.2s;

        &:hover {
            opacity: 1;
        }
    }

    // Types
    &--info {
        background: color-mix(in srgb, var(--color-blue) 10%, transparent);
        color: var(--color-blue);
        border-color: color-mix(in srgb, var(--color-blue) 20%, transparent);
    }

    &--warning {
        background: rgba(var(--color-orange), 0.1);
        color: var(--color-orange);
    }

    &--error {
        background: color-mix(in srgb, var(--color-red) 10%, transparent);
        color: var(--color-red);
        border-color: color-mix(in srgb, var(--color-red) 20%, transparent);
    }
}

// Reuse icon classes or define new
.icon-red {
    path {
        stroke: var(--color-red);
    }
}

.icon-blue {
    path {
        stroke: var(--color-blue);
    }
}

.icon-yellow {
    path {
        stroke: #F59E0B; // Hardcode orange/yellow if variable unknown
    }
}

.notification-banner--warning {
    background: rgba(245, 158, 11, 0.1);
    color: #F59E0B;
    border-color: rgba(245, 158, 11, 0.2);
}

.banner-enter-active,
.banner-leave-active {
    transition: all 0.3s ease;
    max-height: 100px;
    padding: 10px 20px;
    opacity: 1;
}

.banner-enter-from,
.banner-leave-to {
    max-height: 0;
    padding: 0 20px;
    opacity: 0;
    overflow: hidden;
}
</style>
